import { Fragment } from 'react';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages';

const StatsCard = ({
  coursesDone,
  ongoingCourses,
  totalCourses,
  certificatesObtained,
  isEmpty,
}) => {
  const intl = useIntl();

  const stats = [
    { key: 'coursesDone', value: coursesDone, label: intl.formatMessage(messages.coursesDone) },
    { key: 'ongoingCourses', value: ongoingCourses, label: intl.formatMessage(messages.ongoingCourses) },
    { key: 'totalCourses', value: totalCourses, label: intl.formatMessage(messages.totalCourses) },
    { key: 'certificatesObtained', value: certificatesObtained, label: intl.formatMessage(messages.certificatesObtained) },
  ];

  return (
    <div className={`stats-card${isEmpty ? ' stats-card--empty' : ''}`}>
      <div className="stats-card__list">
        {stats.map((stat, index) => (
          <Fragment key={stat.key}>
            {index > 0 && <div className="stats-card__divider" />}
            <div className="stats-card__item">
              <span className="stats-card__value">{stat.value}</span>
              <span className="stats-card__label">{stat.label}</span>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default StatsCard;
